import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { post } from '../../../redux/api';

async function backfillLicenseIdentificationData(): Promise<void> {
  await post('/api/organizations/backfill-license-identification-data', {});
}

/**
 * Hook to backfill license identification data for the current organization.
 * This job will likely run for multiple hours.
 * @returns Mutation function to trigger license identification data backfill
 */
export const useBackfillLicenseIdentificationData = () => {
  return useToastedMutation({
    mutationFn: backfillLicenseIdentificationData,
    successToastMessage: 'License identification data backfill queued successfully',
    errorToastMessage: 'Failed to queue license identification data backfill',
  });
};
